// extracted by mini-css-extract-plugin
export default {"drawerMessage":"DrawerMessage-module_drawerMessage_css0nnbKx6"};